{[ if (o.allow_chat_pending_contacts)  { ]}
<a class="list-item-link open-chat w-100" href="#">
{[ } ]}
<span class="pending-contact-name" title="JID: {{{o.jid}}}">{{{o.display_name}}}</span> 
{[ if (o.allow_chat_pending_contacts)  { ]}</a>{[ } ]}
<a class="list-item-action remove-xmpp-contact far fa-trash-alt" title="{{{o.desc_remove}}}" href="#"></a>
